import React from "react";
import AOS from "aos"
import "aos/dist/aos.css";

class AOSComp extends React.Component {
  componentDidMount() {
     AOS.init({
       // initialise with other settings
       duration: 2000,
     });
  }

  render() {
    return <div></div>;
  }
}

export default AOSComp;
